import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setIsMobile } from 'features/ui/uiSlice';

export const useResponsiveListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 640));
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);
};
